import { createContext, useContext, useEffect, useSyncExternalStore, type ReactNode } from 'react';
import { authStore, type AuthState } from './auth-store';

const AuthContext = createContext<AuthState | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const state = useSyncExternalStore(authStore.subscribe, authStore.getState, authStore.getState);
  useEffect(() => {
    void authStore.getState().bootstrap();
  }, []);
  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export function useCurrentUser() {
  return useAuth().user;
}

export function useIsAdmin(): boolean {
  return useAuth().user?.role === 'ADMIN';
}
